import React from 'react';

interface LogoIconProps {
  size?: number;
  className?: string;
}

const LogoIcon: React.FC<LogoIconProps> = ({ size = 40, className = "" }) => {
  return (
    <div className={`flex items-center justify-center relative ${className}`}>
      {/* Glow effect */}
      <div
        className="absolute blur-xl opacity-70"
        style={{
          background: 'radial-gradient(circle, rgba(168, 85, 247, 0.5) 0%, rgba(236, 72, 153, 0.4) 45%, rgba(249, 115, 22, 0.3) 70%, transparent 100%)',
          width: size * 2,
          height: size * 2,
          borderRadius: '50%'
        }}
      ></div>
      
      {/* Clean image with no background */}
      <img
        src="/chat-logo.png"
        alt="ObsidianAI+ Logo"
        className="relative z-10"
        style={{
          width: size,
          height: size,
          objectFit: 'contain',
          filter: 'drop-shadow(0 0 8px rgba(168, 85, 247, 0.4))'
        }}
      />
    </div>
  );
};

export default LogoIcon;
